const NavbarButton3 = () => {
  return (
    <div className="navbarbutton">
      <a href="./media">Media</a>
    </div>
  );
};

export default NavbarButton3;
